/**
 * Master version embedded in VOD storage keys — source masters live at
 * source/.../v{n}/source.mp4 and packaged outputs at abr/{asset}/v{n}/...
 */
export const versionFromKey = (s3Key?: string | null): number | null => {
  const match = s3Key ? /\/v(\d+)\//.exec(s3Key) : null
  return match ? Number(match[1]) : null
}

/**
 * Version for a rendition row. Packaged HLS/DASH rows carry only a cdn_url
 * (s3_key is null), so fall back to it — but match the full abr/{asset}/v{n}
 * shape: foreign vendor URLs can contain incidental /v1/ path segments that
 * the loose s3_key parse would misread.
 */
export const versionFromRendition = (
  rendition?: { s3_key?: string | null; cdn_url?: string | null } | null
): number | null => {
  if (!rendition) return null
  const fromKey = versionFromKey(rendition.s3_key)
  if (fromKey !== null) return fromKey
  const match = rendition.cdn_url
    ? /\/abr\/[^/]+\/v(\d+)\//.exec(rendition.cdn_url)
    : null
  return match ? Number(match[1]) : null
}
